import { countryOptions } from './addressData'
import {
  ADMIN,
  CATEGORY_USER,
  COLLECTION_CENTER,
  CONSUMER,
  CPCB_GOVERNMENT,
  CPCB_GOVERNMENT_USER,
  CUSTOMER_USER,
  DATA_ENTRY,
  DEALER,
  DEALER_USER,
  DISPOSER,
  DISPOSER_USER,
  DISTRICT_GOVERNMENT,
  DISTRICT_GOVERNMENT_USER,
  NATIONAL_GOVERNMENT,
  NATIONAL_GOVERNMENT_USER,
  OPERATIONS,
  OPERATIONS_USER,
  PROCUREMENT,
  PRODUCER,
  PRODUCER_USER,
  RECYCLER,
  RECYCLING_TECHNICIAN,
  REFURBISHER,
  REFURBISHER_USER,
  SALES,
  SALES_USER,
  SCRAPPING_FACILITY_ENTRY_USER,
  SCRAPPING_FACILITY_MANAGER,
  SECOND_HAND_BUYER,
  SECOND_HAND_BUYER_USER,
  SPCB_GOVERNMENT,
  SPCB_GOVERNMENT_USER,
  SUPER_USER,
  SUPPLIER,
  SUPPLIER_USER,
  THIRD_PARTY_RECYCLER,
  THIRD_PARTY_RECYCLER_USER,
  TRADER,
  TRADER_USER,
  TRANSPORT_CONTRACTOR,
} from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'

const userRelationKey = {
  associate: 'ASSOCIATE',
  nonAssociate: 'NON_ASSOCIATE',
  childAssociate: 'CHILD_AND_ASSOCIATE',
}

const associateKey = {
  user_Consumer: 'user_AssociatedConsumerList',
  user_ScrappingFacility: 'user_AssociatedScrappingFacilityList',
  user_MaterialProducer: 'user_AssociatedMaterialProducerList',
  user_TradingCompany: 'user_AssociatedTradingCompanyList',
  user_Dealer: 'user_AssociatedDealerList',
  user_Producer: 'user_AssociatedProducerList',
  user_3rdPartyRecycler: 'user_Associated3rdPartyRecyclerList',
  user_Disposer: 'user_AssociatedDisposerList',
  user_SecondHandBuyer: 'user_AssociatedSecondHandBuyerList',
  user_Supplier: 'user_AssociatedSupplierList',
  user_TransportContractor: 'user_AssociatedTransportContractor',
  user_CollectionCenter: 'user_AssociatedCollectionCenter',
}

const {
  admin,
  consumer,
  consumerUser,
  dealer,
  dealerUser,
  recycler,
  recyclingTechnician,
  refurbisher,
  refurbisherUser,
  trader,
  traderUser,
  supplier,
  supplierUser,
  producer,
  producerUser,
  thirdPartyRecycle,
  thirdPartyRecycleUser,
  disposer,
  disposerUser,
  secondHandBuyer,
  secondHandBuyerUser,
  transporter,
  nationalGov,
  nationalGovUser,
  cpcbGov,
  cpcbGovUser,
  spcbGov,
  spcbGovUser,
  districtGov,
  districtGovUser,
  site,
  superUser,
  accounts,
  finance,
  compliance,
  collectionCenter,
  dataEntry,
  scrappingFacilityManager,
  categoryUser,
  salesUser,
  operationsUser,
  scrappingFacilityEntryUser,
  procurement,
  operations,
  sales,
} = userWiseRole

const userTranslationKey = {
  [admin]: 'user_Admin',
  [recycler]: 'user_ScrappingFacility',
  [recyclingTechnician]: 'user_RecyclingTechnician',
  [trader]: 'user_TradingCompany',
  [traderUser]: 'user_TradingCompanyUser',
  [superUser]: 'user_SuperUser',
  [accounts]: 'user_AccountsUser',
  [finance]: 'user_FinanceUser',
  [dataEntry]: 'user_DataEntryUser',
  [collectionCenter]: 'user_CollectionCenter',
  [compliance]: 'user_Compliance',
  [consumer]: 'user_Consumer',
  [consumerUser]: 'user_ConsumerUser',
  [dealer]: 'user_Dealer',
  [dealerUser]: 'user_DealerUser',
  [refurbisher]: 'user_MaterialProducer',
  [refurbisherUser]: 'user_MaterialProducerTechnician',
  [disposer]: 'user_Disposer',
  [disposerUser]: 'user_DisposerUser',
  [supplier]: 'user_Supplier',
  [supplierUser]: 'user_SupplierUser',
  [producer]: 'user_Producer',
  [producerUser]: 'user_ProducerUser',
  [thirdPartyRecycle]: 'user_3rdPartyRecycler',
  [thirdPartyRecycleUser]: 'user_3rdPartyRecyclerUser',
  [secondHandBuyer]: 'user_SecondHandBuyer',
  [secondHandBuyerUser]: 'user_SecondHandBuyerUser',
  [nationalGov]: 'user_NationalGovernment',
  [nationalGovUser]: 'user_NationalGovernmentUser',
  [cpcbGov]: 'user_CPCBGovernment',
  [cpcbGovUser]: 'user_CPCBGovernmentUser',
  [spcbGov]: 'user_SPCBGovernment',
  [spcbGovUser]: 'user_SPCBGovernmentUser',
  [districtGov]: 'user_DistrictGovernment',
  [districtGovUser]: 'user_DistrictGovernmentUser',
  [transporter]: 'user_TransportContractor',
  [site]: 'user_Site',
  [thirdPartyRecycle]: 'user_3rdPartyRecycler',
  [secondHandBuyer]: 'user_SecondHandBuyer',
  [scrappingFacilityManager]: 'user_ScrappingFacilityManager',
  [categoryUser]: 'user_CategoryUser',
  [salesUser]: 'user_SalesUser',
  [operationsUser]: 'user_OperationsUser',
  [scrappingFacilityEntryUser]: 'user_ScrappingFacilityEntryUser',
  [procurement]: 'user_Procurement',
  [operations]: 'user_Operations',
  [sales]: 'job_Sales',
}

const roleIdByPath = {
  [ADMIN]: admin,
  [CONSUMER]: consumer,
  [CONSUMER]: consumer,
  [CUSTOMER_USER]: consumerUser,
  [RECYCLER]: recycler,
  [RECYCLING_TECHNICIAN]: recyclingTechnician,
  [DATA_ENTRY]: dataEntry,
  [COLLECTION_CENTER]: collectionCenter,
  [TRANSPORT_CONTRACTOR]: transporter,
  [DEALER]: dealer,
  [DEALER_USER]: dealerUser,
  [REFURBISHER]: refurbisher,
  [REFURBISHER_USER]: refurbisherUser,
  [DISPOSER]: disposer,
  [DISPOSER_USER]: disposerUser,
  [SUPPLIER]: supplier,
  [SUPPLIER_USER]: supplierUser,
  [PRODUCER]: producer,
  [PRODUCER_USER]: producerUser,
  [TRADER]: trader,
  [TRADER_USER]: traderUser,
  [NATIONAL_GOVERNMENT]: nationalGov,
  [NATIONAL_GOVERNMENT_USER]: nationalGovUser,
  [CPCB_GOVERNMENT]: cpcbGov,
  [CPCB_GOVERNMENT_USER]: cpcbGovUser,
  [SPCB_GOVERNMENT]: spcbGov,
  [SPCB_GOVERNMENT_USER]: spcbGovUser,
  [DISTRICT_GOVERNMENT]: districtGov,
  [DISTRICT_GOVERNMENT_USER]: districtGovUser,
  [THIRD_PARTY_RECYCLER]: thirdPartyRecycle,
  [THIRD_PARTY_RECYCLER_USER]: thirdPartyRecycleUser,
  [SECOND_HAND_BUYER]: secondHandBuyer,
  [SECOND_HAND_BUYER_USER]: secondHandBuyerUser,
  [PROCUREMENT]: procurement,
  [OPERATIONS]: operations,
  [SALES]: sales,
  site,
  [SUPER_USER]: superUser,
  accounts,
  finance,
  compliance,
  [SCRAPPING_FACILITY_MANAGER]: scrappingFacilityManager,
  [CATEGORY_USER]: categoryUser,
  [SALES_USER]: salesUser,
  [OPERATIONS_USER]: operationsUser,
  [SCRAPPING_FACILITY_ENTRY_USER]: scrappingFacilityEntryUser,
}

const addUserInitial = {
  businessName: '',
  lastName: '',
  pincode: null,
  country: '',
  state: '',
  city: '',
  address: '',
  emailId: '',
  emailId1: '',
  emailId2: '',
  emailId3: '',
  emailId4: '',
  emailId5: '',
  emailId6: '',
  emailId7: '',
  emailId8: '',
  emailId9: '',
  emailId10: '',
  phoneNumber: '',
  departmentName: '',
  inchargeName: '',
}

const addBuildingInitial = {
  name: '',
  pincode: null,
  country: '',
  state: '',
  city: '',
  address: '',
  emailId: '',
  emailId1: '',
  emailId2: '',
  emailId3: '',
  emailId4: '',
  emailId5: '',
  emailId6: '',
  emailId7: '',
  emailId8: '',
  emailId9: '',
  emailId10: '',
  phoneNumber: '',
}

// const tagsOptions = [
//   { value: 'Automobile', label: 'Automobile' },
//   { value: 'Construction', label: 'Construction' },
//   { value: 'Manufacturing', label: 'Manufacturing' },
//   { value: 'MSW', label: 'MSW' },
//   { value: 'Others', label: 'Others' },
// ]
// const smeltingTypeOptions = [
//   { value: 'Blast', label: 'Blast' },
//   { value: 'EAF', label: 'EAF' },
//   { value: 'IF', label: 'IF' },
// ]

const materialTypeOptions = [
  { label: 'job_Aluminium', value: 'Aluminium' },
  { label: 'job_Battery', value: 'Battery' },
  { label: 'inv_CastIron', value: 'Cast Iron' },
  { label: 'job_Copper', value: 'Copper' },
  { label: 'job_EWaste', value: 'E-Waste' },
  { label: 'job_Glass', value: 'Glass' },
  { label: 'job_Paper', value: 'Paper' },
  { label: 'job_Plastic', value: 'Plastic' },
  { label: 'job_Rubber', value: 'Rubber' },
  { label: 'job_Steel', value: 'Steel' },
  { label: 'job_Textile', value: 'Textile' },
  { label: 'job_UsedOil', value: 'Used Oil' },
]

export const departmentOptions = {
  ACCOUNTING: 'user_Accounting',
  SALES: 'job_Sales',
  OPERATIONS: 'user_Operations',
}

// const energyOptions = [
//   { value: 'Fossil Fuel Only', label: 'Fossil Fuel Only' },
//   { value: 'Renewable Only', label: 'Renewable Only' },
//   {
//     value: 'Combination of Fossil fuel and Renewable',
//     label: 'Combination of Fossil fuel and Renewable',
//   },
//   { value: 'Hydrogen', label: 'Hydrogen' },
// ]

const periodOptions = [
  { label: 'bkm_Weekly', value: 'Weekly' },
  { label: 'bkm_BiWeekly', value: 'Bi-weekly' },
  { label: 'bkm_Monthly', value: 'Monthly' },
  { label: 'bkm_Quarterly', value: 'Quarterly' },
  { label: 'bkm_Yearly', value: 'Yearly' },
]

const commonForm = {
  address: {
    label: 'user_Address',
    validateTrigger: 'onChange',
    inputType: 'autoCompleteAddress',
    required: true,
    md: 24,
    xs: 24,
  },
  city: {
    label: 'user_City',
    validateTrigger: 'onChange',
    inputType: 'input',
    // options: cityOptions,
    required: true,
    md: 12,
    xs: 24,
  },
  state: {
    label: 'user_State',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    md: 12,
    xs: 24,
    // options: stateOptions,
  },
  country: {
    label: 'txt_Country',
    validateTrigger: 'onChange',
    inputType: 'select',
    disabled: true,
    required: true,
    options: countryOptions,
    md: 24,
    xs: 24,
  },
  pincode: {
    label: 'user_Pincode',
    validateTrigger: 'onChange',
    inputType: 'input',
    // options: pincodeOptions,
    className: 'show-clear-icon',
    required: true,
    allowClear: true,
    md: 24,
    xs: 24,
  },
  emailId: {
    label: 'user_Email',
    validateTrigger: 'onChange',
    inputType: 'input',
    validateKey: 'emailId',
    addMore: true,
    maxField: 10,
    addMoreLabel: 'btn_AddMoreEmail',
    addMoreError: 'error_InvalidEmail',
    additionalLabel: 'user_AdditionalEmail',
    md: 24,
    xs: 24,
  },
  phoneNumber: {
    label: 'user_Contact',
    validateTrigger: 'onChange',
    validateKey: 'phoneNumber',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
}

const refurbisherMachineFields = {
  machineTypeId: {
    label: 'user_Type',
    validateTrigger: 'onChange',
    inputType: 'select',
    required: true,
    // options: smeltingTypeOptions,
    className: 'show-clear-icon',
    allowClear: true,
    md: 8,
    xs: 24,
  },
  machineEnergyId: {
    label: 'user_Energy',
    validateTrigger: 'onChange',
    inputType: 'select',
    required: true,
    // options: energyOptions,
    className: 'show-clear-icon',
    allowClear: true,
    md: 8,
    xs: 24,
  },
  capacity: {
    label: 'user_CapacityPerHit',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    className: 'show-clear-icon',
    allowClear: true,
    md: 8,
    xs: 24,
    divider: true,
  },
}

const basicInfoField = {
  profile: {
    validateTrigger: 'onChange',
    inputType: 'formUpload',
    uploadSingle: true,
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
  },
  businessName: {
    label: 'user_BusinessName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
  lastName: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
}

const usernamePasswordField = {
  username: {
    label: 'auth_UserName',
    validateTrigger: 'onChange',
    inputType: 'input',
    autoComplete: 'off',
    required: true,
    md: 24,
    xs: 24,
  },
  password: {
    label: 'auth_Password',
    validateTrigger: 'onChange',
    inputType: 'password',
    required: true,
    autoComplete: 'new-password',
    md: 24,
    xs: 24,
  },
}

const addUserForm = {
  ...basicInfoField,
  sameAsParentBtn: {
    inputType: 'button',
    type: 'primary',
    style: { float: 'right' },
    hidden: true,
    xs: 24,
  },
  ...commonForm,
  panNo: {
    label: 'job_PAN',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  consumerType: {
    label: 'user_RegistrationType',
    validateTrigger: 'onChange',
    inputType: 'RADIO_BUTTON',
    options: [
      { label: 'user_Company', value: 'company' },
      { label: 'user_Individual', value: 'individual' },
    ],
    required: true,
    md: 24,
    xs: 24,
  },
  departmentName: {
    label: 'user_DepartmentName',
    validateTrigger: 'onChange',
    md: 24,
    xs: 24,
    inputType: 'select',
    options: [
      { label: 'user_Accounting', value: 'ACCOUNTING' },
      { label: 'user_Operations', value: 'OPERATIONS' },
      { label: 'job_Sales', value: 'SALES' },
    ],
    hidden: true,
  },
  inchargeName: {
    label: 'user_InChargeName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  ...usernamePasswordField,
}
const addBuildingForm = {
  name: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  ...commonForm,
  contact: {
    label: 'user_Contact',
    validateTrigger: 'onChange',
    validateKey: 'phoneNumber',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
}
delete addBuildingForm.phoneNumber

const collectionCenterForm = {
  profile: {
    validateTrigger: 'onChange',
    inputType: 'formUpload',
    uploadSingle: true,
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
  },
  businessName: {
    label: 'user_BusinessName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
  lastName: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  ...commonForm,
  // departmentName: {
  //   label: 'user_DepartmentName',
  //   validateTrigger: 'onChange',
  //   inputType: 'input',
  //   md: 24,
  //   xs: 24,
  // },
  locationChannelRequestDtos: {},
  inchargeName: {
    label: 'user_InChargeName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  username: {
    label: 'auth_UserName',
    validateTrigger: 'onChange',
    inputType: 'input',
    autoComplete: 'off',
    required: false,
    md: 24,
    xs: 24,
  },
  password: {
    label: 'auth_Password',
    validateTrigger: 'onChange',
    inputType: 'password',
    required: false,
    autoComplete: 'new-password',
    md: 24,
    xs: 24,
  },
}

const governmentUserForm = {
  ...basicInfoField,
  ...commonForm,
  inchargeName: {
    label: 'user_InChargeName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  ...usernamePasswordField,
}

const { type, energy, smelterDetail, capacity, ...customerForm } = addUserForm
const {
  consumerTags: a,
  consumerType: b,
  panNo,
  ...userFormFields
} = customerForm
const { businessName, ...childUserFormFields } = userFormFields

const userFormByRoleId = {
  [refurbisher]: {
    ...basicInfoField,
    ...commonForm,
    otherDoableJobs: {
      label: 'user_DoableJobs',
      validateTrigger: 'onChange',
      inputType: 'checkboxGroup',
      options: [{ label: 'job_SupplierProduction', value: 'Part Production' }],
      md: 24,
      xs: 24,
      required: false,
    },
    materialProducerMaterialTypes: {
      label: 'job_MaterialType',
      validateTrigger: 'onChange',
      inputType: 'select',
      required: true,
      // options: materialTypeOptions,
      className: 'show-clear-icon',
      allowClear: true,
      md: 24,
      xs: 24,
    },
    machineDetails: { hidden: true },
    // departmentName: {
    //   label: 'user_DepartmentName',
    //   validateTrigger: 'onChange',
    //   inputType: 'input',
    //   md: 24,
    //   xs: 24,
    // },
    inchargeName: {
      label: 'user_InChargeName',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
    },
    ...usernamePasswordField,
  },
  [supplier]: {
    ...basicInfoField,
    ...commonForm,
    materialProducerMaterialTypes: {
      label: 'job_MaterialType',
      validateTrigger: 'onChange',
      inputType: 'select',
      required: true,
      className: 'show-clear-icon',
      allowClear: true,
      md: 24,
      xs: 24,
    },
    ...usernamePasswordField,
  },
  [site]: addBuildingForm,
  [collectionCenter]: collectionCenterForm,
  [consumer]: {
    ...customerForm,
    username: { ...usernamePasswordField.username, required: false },
    password: { ...usernamePasswordField.password, required: false },
  },
  [consumerUser]: {
    ...childUserFormFields,
    username: { ...usernamePasswordField.username, required: false },
    password: { ...usernamePasswordField.password, required: false },
  },
  [dealer]: {
    ...basicInfoField,
    ...commonForm,
    // selectionFunctionality: {
    //   label: 'user_SelectionFunctionality',
    //   validateTrigger: 'onChange',
    //   inputType: 'checkboxGroup',
    //   options: [
    //     { label: 'user_CollectionCenter', value: 'user_CollectionCenter' },
    //     { label: 'user_SalesOutlet', value: 'user_SalesOutlet' },
    //   ],
    //   required: true,
    //   md: 24,
    //   xs: 24,
    // },
    locationChannelRequestDtos: {},
    // departmentName: {
    //   label: 'user_DepartmentName',
    //   validateTrigger: 'onChange',
    //   inputType: 'input',
    //   md: 24,
    //   xs: 24,
    // },
    inchargeName: {
      label: 'user_InChargeName',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
    },
    ...usernamePasswordField,
  },
  [recycler]: {
    ...basicInfoField,
    displayName: {
      label: 'user_DisplayName',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
      required: true,
    },
    ...commonForm,
    recyclerRvsfCertification: {
      label: 'user_RVSFCertification',
      validateTrigger: 'onChange',
      inputType: 'RADIO_BUTTON',
      options: [
        { label: 'btn_Yes', value: true },
        { label: 'btn_No', value: false },
      ],
      required: true,
      xs: 24,
    },
    certificateNumber: {
      label: 'user_CertificateNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      required: true,
      xs: 24,
      hidden: true,
    },
    certificateDetails: {
      label: 'user_CertificateUpload',
      validateTrigger: 'onChange',
      inputType: 'formUpload',
      uploadSingle: true,
      required: true,
      acceptFileTypes: '.png,.jpg,.jpeg,.webp,.pdf',
      xs: 24,
      hidden: true,
    },
    // departmentName: {
    //   label: 'user_DepartmentName',
    //   validateTrigger: 'onChange',
    //   inputType: 'input',
    //   md: 24,
    //   xs: 24,
    // },
    gstNumber: {
      label: 'user_GSTNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
      divider: true,
      // required: true,
    },

    picDetails: {
      title: 'user_PICDetails',
      hidden: true,
    },
    inchargeName: {
      label: 'user_AuthorisedPersonName',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
      // required: true,
    },
    inchargeEmail: {
      label: 'user_AuthorisedPersonEmail',
      validateTrigger: 'onChange',
      inputType: 'input',
      validateKey: 'emailId',
      // required: true,
      md: 24,
      xs: 24,
    },
    inchargePhone: {
      label: 'user_AuthorisedPersonMobileNumber',
      validateTrigger: 'onChange',
      validateKey: 'phoneNumber',
      inputType: 'input',
      md: 24,
      xs: 24,
    },

    consent: {
      title: 'user_ConsentValidity',
      hidden: true,
    },
    recyclerAirActDate: {
      label: 'user_UnderAirAct1981ValidUpTo',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      className: 'w-100',
      md: 12,
      xs: 24,
    },
    recyclerWaterActDate: {
      label: 'user_UnderWaterAct1974ValidUpTo',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      className: 'w-100',
      md: 12,
      xs: 24,
      divider: true,
    },
    recyclerAuthorisationValidityDate: {
      label:
        'user_ValidityOfAuthorisationUnderRule6OfTheHazardousWastesManagementAndHandlingRules2016',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      className: 'w-100',
      xs: 24,
    },
    recyclerCertificationValidityDate: {
      label:
        'user_ValidityOfCertificationOfRegistrationWithDistrictIndustriesCentre',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      className: 'w-100',
      xs: 24,
    },
    recyclerCategoryDetails: {
      label: 'user_RecyclerFormField1',
      validateTrigger: 'onChange',
      inputType: 'input',
      xs: 24,
      divider: true,
      // required: true,
    },

    capacityOfRegisterVehicle: {
      title: 'user_RecyclerFormField2',
      hidden: true,
    },
    recyclerInstalledCapacityOfVehicle: {
      label: 'user_Installed',
      validateTrigger: 'onChange',
      inputType: 'input',
      xs: 24,
      md: 12,
    },
    recyclerOperatingCapacityOfVehicle: {
      label: 'user_OperatingDetailsOfLastThreeYears',
      validateTrigger: 'onChange',
      inputType: 'input',
      xs: 24,
      md: 12,
      divider: true,
    },

    ...usernamePasswordField,
  },
  [producer]: {
    ...basicInfoField,
    ...commonForm,
    gstNumber: {
      label: 'user_GSTNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
      // required: true,
    },
    producerTinNumber: {
      label: 'userTINNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
      // required: true,
    },
    producerCpcbCertification: {
      label: 'user_CPCBCertification',
      validateTrigger: 'onChange',
      inputType: 'RADIO_BUTTON',
      options: [
        { label: 'btn_Yes', value: true },
        { label: 'btn_No', value: false },
      ],
      required: true,
      md: 24,
      xs: 24,
    },
    certificateNumber: {
      label: 'user_CertificateNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      required: true,
      xs: 24,
      hidden: true,
    },
    certificateDetails: {
      label: 'user_CertificateUpload',
      validateTrigger: 'onChange',
      inputType: 'formUpload',
      uploadSingle: true,
      required: true,
      acceptFileTypes: '.png,.jpg,.jpeg,.webp,.pdf',
      xs: 24,
      hidden: true,
    },
    // departmentName: {
    //   label: 'user_DepartmentName',
    //   validateTrigger: 'onChange',
    //   inputType: 'input',
    //   md: 24,
    //   xs: 24,
    // },
    inchargeName: {
      label: 'user_InChargeName',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      xs: 24,
    },
    modelNames: {
      xs: 24,
    },
    ...usernamePasswordField,
  },
  [nationalGov]: governmentUserForm,
  [cpcbGov]: governmentUserForm,
  [spcbGov]: governmentUserForm,
  [districtGov]: governmentUserForm,
}

//based on material selection
const refurbisherMachineTitle = {
  job_Steel: 'user_SteelMachineDetails',
  job_Rubber: 'user_RubberMachineDetails',
  job_Aluminium: 'user_AluminiumMachineDetails',
  job_Copper: 'user_CopperMachineDetails',
  job_Plastic: 'user_PlasticMachineDetails',
  job_Glass: 'user_GlassMachineDetails',
  job_Paper: 'user_PaperMachineDetails',
  job_Textile: 'user_TextileMachineDetails',
  job_EWaste: 'user_EWasteMachineDetails',
  job_Battery: 'user_BatteryMachineDetails',
  job_UsedOil: 'user_UsedOilMachineDetails',
  job_BlackMass: 'user_BlackMassMachineDetails',
  inv_CastIron: 'user_CastIronMachineDetails',
  inv_Foam: 'user_FoamMachineDetails',
  inv_Freon: 'user_FreonMachineDetails',
  inv_Lead: 'user_LeadMachineDetails',
  inv_Mix: 'user_MixMachineDetails',
  inv_PlatinumAndPalladium: 'user_PlatinumAndPalladiumMachineDetails',
}

const fuelTypeOptions = [
  { label: 'ful_CNG', value: 'CNG' },
  { label: 'ful_Diesel', value: 'Diesel' },
  { label: 'ful_EV', value: 'EV' },
  { label: 'ful_Hybrid', value: 'Hybrid' },
  { label: 'ful_Petrol', value: 'Petrol' },
]

const userSearchByOptions = [
  { label: 'user_BusinessName', value: 'businessName' },
  { label: 'user_State', value: 'state' },
]

const RATING_LENGTH = 5

export const priorityOptions = t => [
  { label: t('user_Reminder'), value: 'REMINDER' },
  { label: t('user_FollowUp'), value: 'FOLLOW_UP' },
  { label: t('user_Urgent'), value: 'URGENT' },
]

export {
  addBuildingForm,
  addBuildingInitial,
  addUserInitial,
  associateKey,
  childUserFormFields,
  fuelTypeOptions,
  materialTypeOptions,
  periodOptions,
  RATING_LENGTH,
  refurbisherMachineFields,
  refurbisherMachineTitle,
  roleIdByPath,
  userFormByRoleId,
  userFormFields,
  userRelationKey,
  userSearchByOptions,
  userTranslationKey,
}
